//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import CartView from '@app/Cart/View'
import ModalWrapper from '@app/Forms/ModalWrapper'
import { confirmWithPromise } from '@utils/helpers'

import {
  AnswerMessage,
} from '@utils/submit'

export default {
  name: 'AddToCart',
  props: {
    objects: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapActions('cart', [
      'changeCart',
    ]),
    async addToCart() {
      const entities = []
      this.objects.forEach(item => {
        const data = {
          element: {
            id: item.base.element.id,
            type: item.base.element.type,
          },
          quantity: item.base.quantity,
        }
        entities.push(data)
      })
      try {
        const question = this._('Додати товари з замовлення до кошику?')
        await confirmWithPromise(question, this)
        await this.changeCart({ entities })
        this.openCart()
        this.$emit('success')
      } catch (e) {
        console.log(e);
        if (!e) return
        const meta = {
          messages: [{
            title: this._('Максимальна кількость товарів перевищена.'),
            // eslint-disable-next-line prefer-template
            // text: this._('Цей Товар можна замовити лише у кількості') + ' ' + this.maxCount + ' ' + this._('шт.'),
            text: this._('Деякі товари вже недоступні.'),
          }],
          timeout: 5000,
        }
        AnswerMessage(meta, this)
      }
    },
    openCart() {
      this.$modal.show(
        ModalWrapper,
        {
          info: {
            tag: CartView,
          },
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
